const gnbData = [ // Navigation Depth List
    {
        name: '탕전실소개',
        path: '',
        children: [{
            name: '인사말',
            path: '/introduce',
        },
        // {
        //     name: '탕전시스템소개',
        //     path: '',
        // },
        {
            name: '탕전실 둘러보기',
            path: '/aroundView',
        },
        {
            name: '오시는 길',
            path: '/locationView',
        },
    ]        
    },
    {
        name: '탕전신청',
        path: '/application',
    },
    {
        name: '첩약건보',
        path: '/insurance',
    },
    {
        name: '약속처방',
        path: '/promisGoodsList',
    },
    {
        name: '커뮤니티',
        path: '',
        children: [{
                name: '공지사항',
                path: '/notice',
            },
            {
                name: '자료실',
                path: '',
            },
            {
                name: 'QnA',
                path: '/qna',
            },
            {
                name: '코끼리비방사전',
                path: '/elepantSecretPrescriptionList',
            },
            {
                name: '처방문답',
                path: '/formulaQna',
            },
        ]
    },
    {
        name: '마이페이지',
        path: '',
        children: [{
                name: '내정보',
                path: '/mypage/myInfo',
            },
            {
                name: '환자관리',
                path: '/mypage/patientMngt',
            },
            {
                name: '내처방관리',
                path: '/mypage/myPrescribeList',
            },
            {
                name: '내 비방 관리',
                path: '/mypage/mySecretPrescriptionList',
            },
            {
                name: '장바구니',
                path: '/mypage/orderCheckoutList',
            },
            {
                name: '처방내역',
                path: '/mypage/PrescriptionList',
            },
        ]
    }
]

export { gnbData }